import type { GetWhatsNewQuery } from "~/gql/queries/whatsNew.generated";
import type { GetMyWhatsNewEmailQuery } from "~/gql/queries/whatsNewEmail.generated";

const whatsNewEndpoints = {
	RequestEarlyAccess: { invalidatesTags: ["WhatsNew"] as AddTagTypes },
	GetMyWhatsNewEmail: {
		providesTags: ["Me"] as AddTagTypes,
		transformResponse: (res: GetMyWhatsNewEmailQuery) => res
	},
	GetWhatsNew: {
		providesTags: ["WhatsNew"] as AddTagTypes,
		transformResponse: (res: GetWhatsNewQuery) => res
	},
	SetMyWhatsNewEmail: {
		invalidatesTags: ["Me"] as AddTagTypes
	}
};
export default whatsNewEndpoints;
